import React, { useContext, useEffect } from "react";

import { useGetSpecificFormQuery } from "../../../../Redux/service/Forms/Form";
import { popupcontext } from "../../../../context/Popupscontext";
import Popup from "../../../Helpers/Popup/Popup";
import Loader from "../../../Helpers/Loader/Loader";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import AntCalendar from "../../../FormBuilderInputs/Calendar";
import AntCheckBox from "../../../FormBuilderInputs/CheckBox";
import AntDatePicker from "../../../FormBuilderInputs/DatePicker";
import DropdownInput from "../../../FormBuilderInputs/DropdownInput";
import NormalInput from "../../../FormBuilderInputs/NormalInput";
import RadioGroup from "../../../FormBuilderInputs/RadioGroup";
import AntTextArea from "../../../FormBuilderInputs/TextArea";
import Toggle from "../../../FormBuilderInputs/Toggle";
import AntUpload from "../../../FormBuilderInputs/Upload";
import AntButton from "../../../FormBuilderInputs/Button";
import AntHeader from "../../../FormBuilderInputs/Header";
import Image from "../../../FormBuilderInputs/Image";
import Label from "../../../FormBuilderInputs/Label";
import Link from "../../../FormBuilderInputs/Link";
import ProgressCircle from "../../../FormBuilderInputs/ProgressCircle";
import ProgressLine from "../../../FormBuilderInputs/ProgressLine";
import UISignature from "../../../FormBuilderInputs/Signature";
import SnippetCamera from "../../../FormBuilderInputs/Camera";
import ContainerPreview from "../../../FormBuilderInputs/ContainerPreview";

export default function FormsPopup({ formId, type, onClose }) {
	let { handleClose, edited } = useContext(popupcontext);
	let { data, isLoading, refetch } = useGetSpecificFormQuery(formId, {
		skip: !formId,
	});
	useEffect(() => {
		if (edited) {
			refetch();
		}
	}, [edited, refetch]);
	const closeform = () => {
		if (type === "form") {
			handleClose("display");
		}
		if (type === "task") {
			onClose();
		}
	};
	const getInputType = (item) => {
		switch (item?.name) {
			case "Checkbox":
				return <AntCheckBox item={item} />;
			case "DatePicker":
				return <AntDatePicker item={item} preview={true} />;
			case "Dropdown":
				return <DropdownInput item={item} preview={true} />;

			case "Input":
				return <NormalInput item={item} preview={true} />;
			case "Container":
				return (
					<ContainerPreview
						getInputType={getInputType}
						ukey={item?.id}
						item={item?.container}
						css={item?.css}
					/>
				);
			case "Radio_group":
				return <RadioGroup item={item} preview={true} />;

			case "Text_area":
				return <AntTextArea item={item} preview={true} />;

			case "Toggle":
				return <Toggle item={item} />;
			case "Uploader":
				return <AntUpload item={item} />;
			case "Button":
				return <AntButton item={item} />;

			case "Header":
				return <AntHeader item={item} />;
			case "Image":
				return <Image item={item} />;
			case "Label":
				return <Label item={item} />;
			case "Link":
				return <Link item={item} />;

			case "Progress_circle":
				return <ProgressCircle item={item} />;
			case "Progress_line":
				return <ProgressLine item={item} />;
			case "Signature":
				return <UISignature item={item} preview={true} />;
			case "Camera":
				return <SnippetCamera item={item} preview={true} />;
			default:
				return;
		}
	};
	console.log("this form is open");
	return (
		<Popup show={!!formId} zIndex={1060}>
			{isLoading && (
				<div className="loader-container">
					<Loader />
				</div>
			)}
			<Modal.Header className="modal-header flex-between ">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle
						headtitle={`${data?.data?.name}`}
						subtitle={`${data?.data?.code}`}
					/>
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={closeform}
					img="Close"
				/>
			</Modal.Header>
			<Modal.Body
				className="modal-body-scrollable"
				style={{ height: "calc(100vh - 140px)", overflowX: "hidden" }}
			>
				{data?.data?.formSchema?.fields.map((i) => (
					<div className={`mb-2`} style={i.css}>
						{getInputType(i)}
					</div>
				))}
			</Modal.Body>
		</Popup>
	);
}
